var _rect, _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5256 -9711C-5256 -9764.02 -5213.02 -9807 -5160 -9807H11782C11835 -9807 11878 -9764.02 11878 -9711V19183C11878 19236 11835 19279 11782 19279H-5160C-5213.02 19279 -5256 19236 -5256 19183V-9711Z",
    fill: "#EEF6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-5160 -9792H11782V-9822H-5160V-9792ZM11863 -9711V19183H11893V-9711H11863ZM11782 19264H-5160V19294H11782V19264ZM-5241 19183V-9711H-5271V19183H-5241ZM-5160 19264C-5204.74 19264 -5241 19227.7 -5241 19183H-5271C-5271 19244.3 -5221.3 19294 -5160 19294V19264ZM11863 19183C11863 19227.7 11826.7 19264 11782 19264V19294C11843.3 19294 11893 19244.3 11893 19183H11863ZM11782 -9792C11826.7 -9792 11863 -9755.74 11863 -9711H11893C11893 -9772.3 11843.3 -9822 11782 -9822V-9792ZM-5160 -9822C-5221.3 -9822 -5271 -9772.3 -5271 -9711H-5241C-5241 -9755.74 -5204.74 -9792 -5160 -9792V-9822Z",
    fill: "#5DA5D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-3026 -449C-3026 -484.346 -2997.35 -513 -2962 -513H6262C6297.35 -513 6326 -484.346 6326 -449V1831C6326 1866.35 6297.35 1895 6262 1895H-2962C-2997.35 1895 -3026 1866.35 -3026 1831V-449Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-2962 -503H6262V-523H-2962V-503ZM6316 -449V1831H6336V-449H6316ZM6262 1885H-2962V1905H6262V1885ZM-3016 1831V-449H-3036V1831H-3016ZM-2962 1885C-2991.82 1885 -3016 1860.82 -3016 1831H-3036C-3036 1871.87 -3002.87 1905 -2962 1905V1885ZM6316 1831C6316 1860.82 6291.82 1885 6262 1885V1905C6302.87 1905 6336 1871.87 6336 1831H6316ZM6262 -503C6291.82 -503 6316 -478.823 6316 -449H6336C6336 -489.869 6302.87 -523 6262 -523V-503ZM-2962 -523C-3002.87 -523 -3036 -489.869 -3036 -449H-3016C-3016 -478.823 -2991.82 -503 -2962 -503V-523Z",
    fill: "#5DA5D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_44749)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1166,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1166,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "url(#paint0_linear_378_44749)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_378_44749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-309 3.8147e-06C-309 -16.0163 -296.016 -29 -280 -29H73V394C73 410.016 60.0163 423 44 423H-280C-296.016 423 -309 410.016 -309 394V3.8147e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 3.8147e-06C-309 -16.0163 -296.016 -29 -280 -29H73V394C73 410.016 60.0163 423 44 423H-280C-296.016 423 -309 410.016 -309 394V3.8147e-06Z",
    stroke: "#E9EDF4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D4DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9008 18.2125H26.6133V15.4375C26.6133 12.8875 24.5508 10.825 22.0008 10.825C19.4508 10.825 17.4258 12.8875 17.4258 15.4375V18.2125H15.1383C13.7133 18.2125 12.5508 19.3375 12.5508 20.6875V26.1249C12.5508 29.9874 15.8883 33.1374 19.9758 33.1374H24.1008C28.1883 33.1374 31.4883 29.9499 31.4883 26.0125V20.6875C31.4883 19.3375 30.3258 18.2125 28.9008 18.2125ZM19.1133 15.4375C19.1133 13.825 20.4258 12.5125 22.0383 12.5125C23.6508 12.5125 24.9633 13.825 24.9633 15.4375V18.2125H19.1133V15.4375ZM29.8008 26.0125C29.8008 29.0124 27.2508 31.4499 24.1008 31.4499H19.9758C16.8258 31.4499 14.2383 29.0499 14.2383 26.1249V20.6875C14.2383 20.2374 14.6508 19.9 15.1383 19.9H28.9008C29.3883 19.9 29.8008 20.2374 29.8008 20.6875V26.0125Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5391 24.7749H20.4641C19.7891 24.7749 19.2266 25.3374 19.2266 26.0124V29.0874C19.2266 29.7624 19.7891 30.3249 20.4641 30.3249H23.5391C24.2141 30.3249 24.7766 29.7624 24.7766 29.0874V26.0124C24.7766 25.3374 24.2141 24.7749 23.5391 24.7749ZM23.0891 28.5999H20.9516V26.4624H23.0891V28.5999Z",
    fill: "#6B7280"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_378_44749",
    x1: -526,
    y1: -367,
    x2: -526,
    y2: 165.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F7FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1166,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 861,
    fill: "white",
    transform: "translate(-1166 -317)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.0ed1ff83214928ab01f152dbdafc8dda.svg";
export { ForwardRef as ReactComponent };